export const CURRENCIES = ["USD", "RMB", "INR", "HKD", "AED", "EUR", "GBP", "ZAR", "Other"];

export const ENTRY_TYPES = [
  "Money Received",
  "Money Paid",
  "Expense",
  "Transfer Between Own Accounts",
  "Adjustment",
  "Refund Received",
  "Refund Paid",
];

// Expense is legacy: hidden for NEW entries (use Money Paid → General / Office Expense)
export const NEW_ENTRY_TYPES = ENTRY_TYPES.filter((t) => t !== "Expense");

export const PAYMENT_SCOPES = [
  { value: "PI/Order", label: "PI / Order Related", hint: "Factory, freight, forwarding, customs, commission…" },
  { value: "Purchase/Stock", label: "Purchase / Stock", hint: "Bobbins, needles, threads, spare parts, packing…" },
  { value: "General/Office", label: "General / Office Expense", hint: "Salary, rent, taxi, food, utilities, marketing…" },
];

export const PAYMENT_MODES = ["Cash", "Bank", "Digital Wallet", "Credit Card", "Other"];

export const PARTY_TYPES = [
  "Customer", "Factory", "Supplier", "Employee", "Agent",
  "Transporter", "Service Provider", "Personal", "Other",
];

export const FACTORY_PAYMENT_TYPES = [
  "Factory Advance", "Second Payment", "Factory Balance", "Parts Payment", "Sample Payment", "Other",
];

export const CUSTOMER_RECEIPT_TYPES = [
  "Customer Advance", "Second Payment", "Customer Balance", "Refund Recovery", "Other",
];

export const PAYMENT_TYPES = [
  "Factory Payment", "Freight", "Forwarding", "Customs / Duty", "Commission", "Other PI-related Expense",
];

export const STATUS_OPTIONS = [
  "New", "Checked by Jatin", "Entered into Tally", "Clarification Required", "Completed",
];

export function directionFromEntryType(t) {
  if (t === "Money Received" || t === "Refund Received") return "Money In";
  if (t === "Money Paid" || t === "Expense" || t === "Refund Paid") return "Money Out";
  if (t === "Transfer Between Own Accounts") return "Internal Transfer";
  return "Adjustment";
}
